<template>
  <div class="admin-website">
    <PageHeader>
      <div class="heading">
        <h1>
          <router-link :to="{name: 'admin-actions'}">Admin Actions</router-link>
          / <strong class="name">Generate Certificate</strong>
        </h1>
      </div>
    </PageHeader>

    <div class="page-columns">
      <div class="col main">
        <div class="page-content admin-certificate">
          <div class="admin-certificate-form">
            <CreateCertificateForm
              v-model="job"
              @submit="createCertificate"
              :errors="errors"
              :websites="websites"
              :companies="companies"/>
            <p v-if="certificateGenerating">Please wait...</p>
            <p>{{certificateMessage}}</p>
          </div>
        </div>
      </div>

      <div class="col side">
        <PageSummary>
          <div>
            <h1>Generate a Certificate</h1>
            <p>
              Generate a new SSL certificate for a domain pointing to our IP Address.
            </p>
          </div>
        </PageSummary>
      </div>
    </div>
  </div>
</template>

<script>
import CreateCertificateForm from '@/components/forms/CreateCertificateForm'
import PageHeader from '@/components/PageHeader'
import PageSummary from '@/components/PageSummary'

import {mapState} from 'vuex'

import page from '@/mixins/page'

import {createCompanySiteCertificateData} from '@/lib/certificates'
import {readCompaniesData} from '@/lib/companies'
import {readCompanySitesData} from '@/lib/sites'

export default {
  name: 'admin-certificate',

  mixins: [page],

  data() {
    return {
      job: {},
      errors: {},
      title: 'Generate SSL Certificate',
      certificateGenerating: false,
      certificateMessage: '',
      companies: [],
      websites: [],
      page: {page: 1, page_size: 500}
    }
  },

  components: {
    CreateCertificateForm,
    PageHeader,
    PageSummary
  },

  computed: {
    ...mapState(['currentUser']),

    usersOptions() {
      const user = this.currentUser

      return [
        {
          key: user.email,
          value: user.id
        }
      ]
    }
  },

  methods: {
    getData() {
      readCompaniesData(this.page).then(({data}) => {
        data.forEach((company) => {
          this.companies.push({
            key: company.name,
            value: company.id
          })
        })
      })
    },

    getCompanySites() {
      readCompanySitesData(this.job.companyId, this.page).then(({data}) => {
        this.websites = []

        data.forEach((site) => {
          this.websites.push({
            key: site.name,
            value: site.id
          })
        })
      })
    },

    startJob() {
      this.createCertificate()
    },

    createCertificate() {
      let cert = {
        company_id: this.job.companyId,
        is_preview: false,
        domain: this.job.domain
      }

      this.certificateGenerating = true

      createCompanySiteCertificateData(this.job.companyId, this.job.siteId, cert)
        .then(({data}) => {
          this.certificateGenerating = false
          this.certificateMessage = 'Certificate successfully generated!'
        })
        .catch(({response}) => {
          this.certificateGenerating = false
          this.certificateMessage = 'Certificate could not be generated.'
        })
    }
  },

  mounted() {
    this.getData()
  },

  watch: {
    'job.companyId'() {
      this.getCompanySites()
    }
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/base/theme'
@import '../../stylesheets/helpers/mixins'
</style>
